module.exports = {"650202001":"金山路街道","650202002":"西宁路街道","650202003":"新北区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650202.json
// module id = 3058
// module chunks = 0